const allowedTags = new Set(['B', 'BR', 'P', 'PRE', 'STRONG']);

export const sanitizeHtml = (html) => {
  if (!html) {
    return '';
  }

  const documentNode = new DOMParser().parseFromString(String(html), 'text/html');

  Array.from(documentNode.body.querySelectorAll('*')).forEach((element) => {
    if (!allowedTags.has(element.tagName)) {
      element.replaceWith(...element.childNodes);
      return;
    }

    Array.from(element.attributes).forEach((attribute) => {
      const keepCodeClass = element.tagName === 'PRE'
        && attribute.name === 'class'
        && attribute.value === 'prettyprint';
      if (!keepCodeClass) {
        element.removeAttribute(attribute.name);
      }
    });
  });

  return documentNode.body.innerHTML;
};
